import React, { useState, useEffect } from "react";

function NetworkStatus() {
  const [networkType, setNetworkType] = useState("");
  const [onlineStatus, setOnlineStatus] = useState(window.navigator.onLine);

  useEffect(() => {
    function handleNetworkChange(event) {
      switch (event.type) {
        case "wifi":
          setNetworkType("WiFi");
          break;
        case "ethernet":
          setNetworkType("Ethernet");
          break;
        case "cellular":
          setNetworkType("Cellular");
          break;
        default:
          setNetworkType("");
          break;
      }
    }

    function handleOnlineStatus() {
      setOnlineStatus(true);
    }

    function handleOfflineStatus() {
      setOnlineStatus(false);
    }

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOfflineStatus);
    window.addEventListener("wifi", handleNetworkChange);
    window.addEventListener("ethernet", handleNetworkChange);
    window.addEventListener("cellular", handleNetworkChange);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
      window.removeEventListener("wifi", handleNetworkChange);
      window.removeEventListener("ethernet", handleNetworkChange);
      window.removeEventListener("cellular", handleNetworkChange);
    };
  }, []);

  return (
    <div>
      {onlineStatus ? (
        <p>
          You are connected to {networkType || "the internet"} network.
        </p>
      ) : (
        <p>You are not connected to the internet.</p>
      )}
    </div>
  );
}

export default NetworkStatus;
